import { NgModule, inject } from '@angular/core';

import { FuseMediaWatcherService } from './media-watcher.service';
@NgModule({
  providers: [FuseMediaWatcherService]
})
export class FuseMediaWatcherModule {
  private __fuseMediaWatcherService = inject(FuseMediaWatcherService);
}
